import { Span } from '@dnb/eufemia';

export const typeToBadgeText: Record<string, string> = {
  API: 'API',
  EVENT: 'Event',
  APP: 'App',
  TEAM: 'Team',
  CLIENT: 'Client',
  SCOPE: 'Scope',
  CONTENT: 'Content',
  FAQ: 'FAQ',
  GETTING_STARTED: 'Getting Started',
  GUIDE: 'Guide',
  REFERENCE: 'Ref.',
  MCP: 'MCP',
  MCP_GUIDE: 'MCP',
  CONSUMER_APP_ENTITLEMENT_REQUEST: 'App',
  PROVIDER_APP_ENTITLEMENT_REQUEST: 'API',
};

const typeToBadgeColor: Record<string, string> = {
  API: 'bg-summer-green',
  EVENT: 'bg-sky-blue',
  APP: 'bg-blue-500',
  TEAM: 'bg-sea-green',
  CLIENT: 'bg-purple-700',
  SCOPE: 'bg-indigo-800',
  CONTENT: 'bg-orange-500',
  FAQ: 'bg-orange-500',
  GETTING_STARTED: 'bg-emerald-600',
  // GUIDE and REFERENCE share the same color as API for visual consistency
  GUIDE: 'bg-summer-green',
  REFERENCE: 'bg-summer-green',
  MCP: 'bg-violet',
  MCP_GUIDE: 'bg-violet',
  CONSUMER_APP_ENTITLEMENT_REQUEST: 'bg-blue-500',
  PROVIDER_APP_ENTITLEMENT_REQUEST: 'bg-summer-green',
};

function getBadgeColor(type: string): string {
  return typeToBadgeColor[type] ?? 'bg-gray-500';
}

interface TypeBadgeProps {
  type: string;
}

export function TypeBadge({ type }: TypeBadgeProps) {
  const badgeText = typeToBadgeText[type] ?? type;
  const badgeColor = getBadgeColor(type);

  return (
    <Span
      className={`inline-block text-white text-center ${badgeColor} w-auto px-2 py-1 rounded-lg text-xs font-medium whitespace-nowrap`}
    >
      {badgeText}
    </Span>
  );
}
